const BASE_URL = '/api/content/'

export const useContent = () => {
  const config = useRuntimeConfig()

  const { fetchGet, fetchPost, fetchPostForm } = useCustomFetch()

  function getContent(id: string): Promise<Content> {
    return fetchGet(BASE_URL + id)
  }

  function searchContent(query: SearchQuery): Promise<SearchResult<Content>> {
    return fetchGet(BASE_URL + 'search' + toSearchQueryString(query))
  }

  function createContentMeta(content: Content): Promise<Content> {
    return fetchPost(BASE_URL + 'create-meta', content)
  }

  function updateContentMeta(content: Content): Promise<Content> {
    return fetchPost(BASE_URL + 'update-meta', content)
  }

  function deleteContent(c: Content): Promise<JpsResponse> {
    return fetchPost(BASE_URL + c.id + '/delete')
  }

  function addImage(contentId: string, file: File): Promise<Content> {
    let formData = new FormData()
    formData.append('file', file)
    formData.append('content', contentId)
    return fetchPostForm(BASE_URL + 'add-image', formData)
  }

  function updateImage(
    contentId: string,
    imageId: string,
    file: File,
  ): Promise<Content> {
    let formData = new FormData()
    formData.append('file', file)
    formData.append('content', contentId)
    formData.append('image', imageId)
    return fetchPostForm(BASE_URL + 'update-image', formData)
  }

  function deleteImage(contentId: string, imageId: string): Promise<Content> {
    return fetchPostForm(BASE_URL + 'delete-image', {
      content: contentId,
      image: imageId,
    })
  }

  function contentManifestUrl(contentId: string) {
    return `/api/iiif/${contentId}/manifest.json`
  }

  function contentInfoUrl(contentId: string, imageId: string) {
    return `/api/iiif/${contentId}-${imageId}/info.json`
  }

  const { iiifImageUrlFromInfo } = useIIIF()

  function iiifImageUrlFromContent(
    contentId: string,
    imageId: string,
    trim?: IIIFTrimParam,
    size?: IIIFSizeParam,
  ) {
    return iiifImageUrlFromInfo(contentInfoUrl(contentId, imageId), trim, size)
  }

  function contentFullImageUrl(contentId: string, imageId: string) {
    return `/image/${contentId}-${imageId}.jpg`
  }

  function contentImageUrl(contentId: string, imageId: string) {
    return `/image/${contentId}-${imageId}_med.jpg`
  }

  function contentThumbnailUrl(contentId: string, imageId: string) {
    return `/image/${contentId}-${imageId}_thumb.jpg`
  }

  return {
    getContent,
    searchContent,
    createContentMeta,
    updateContentMeta,
    deleteContent,
    addImage,
    updateImage,
    deleteImage,
    contentManifestUrl,
    contentInfoUrl,
    iiifImageUrlFromContent,
    contentFullImageUrl,
    contentImageUrl,
    contentThumbnailUrl,
  }
}
